export default __webpack_public_path__ + "static/media/arequipa-mountains_night.6d7342ac.jpg";